import React from 'react';
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import iconCamaraUser from '../../../assets/img/camara-user.png';
import iconCard from '../../../assets/img/user-card.png';

const CardIdentityValidation = (props) => {
  const { disabled } = props;
  return (
    <SimpleCard
      disabled={disabled}
      contentHeader={
        <p className="simplecard__title">Para verificar tu identidad, necesitarás:</p>
      }
    >
      <Grid row className="m-0 p-2 p-md-6 justify-content-around align-items-center">
        {/* Cédula de identidad */}
        <Grid
          className="p-0 d-flex flex-row align-items-start"
          col={12}
          md={5}
        >
          <img src={iconCard} alt="Ícono cédula" width="64" height="64" className="mr-3" />
          <div>
            <p className="font-size-16 line-height-22 font-weight-bold mb-1">
              Cédula de identidad
            </p>
            <p className="font-size-14 line-height-20 m-0">
              Vigente y en buen estado. Debes sacarle una foto con tu celular.
            </p>
          </div>
        </Grid>

        {/* Celular con cámara */}
        <Grid
          className="p-0 d-flex flex-row align-items-start mt-3 mt-md-0"
          col={12}
          md={5}
        >
          <img src={iconCamaraUser} alt="Ícono cámara" width="64" height="64" className="mr-3" />
          <div>
            <p className="font-size-16 line-height-22 font-weight-bold mb-1">
              Celular con cámara
            </p>
            <p className="font-size-14 line-height-20 m-0">
              Para saber que eres tú, te pediremos una foto o selfie desde tu smartphone.
            </p>
          </div>
        </Grid>
      </Grid>
    </SimpleCard>
  );
};

export default CardIdentityValidation;
